import {React, observer, IDisposer, useEffect, classNames, useAsObservableSource} from '@api'
import {Accordion, AccordionDetails, AccordionSummary, Checkbox, FormControlLabel} from '@material-ui/core'
import {KeyboardArrowDown} from '@material-ui/icons'
import {useVipLocalStore, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'
import * as css from './ChangeLogFilterActions.css'

/// region Store

export class ChangeLogFilterActionsStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)
  }

  get label() {
    return this.props.label
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }
}

export const ChangeLogFilterActionsStoreContext = React.createContext<ChangeLogFilterActionsStore>(null)
export const useChangeLogFilterActionsStore = () => React.useContext(ChangeLogFilterActionsStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
  label: string
}

const TYPES = ['Added', 'Changed', 'Deleted']

export const ChangeLogFilterActions = observer<MyProps>(function ChangeLogFilterActions({className, ...props}) {
  const obsProps = useAsObservableSource({...props}),
    store = useVipLocalStore((stores) => new ChangeLogFilterActionsStore(stores, obsProps)),
    {label} = store

  useEffect(() => store.registerEffects(), [])

  return (
    <ChangeLogFilterActionsStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)}>
        <Accordion elevation={0} classes={{expanded: css.expanded}}>
          <AccordionSummary data-type={'summary-action-field'} expandIcon={<KeyboardArrowDown/>}>{label}</AccordionSummary>
          <AccordionDetails data-type={'details-action-field'}>
            {TYPES.map(type => <FormControlLabel key={type} control={<Checkbox/>} label={type}/>)}
          </AccordionDetails>
        </Accordion>
      </div>
    </ChangeLogFilterActionsStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/changelog/ChangeLogFilterActions.tsx